export default __webpack_public_path__ + "static/media/Degraded Fairy.e430b27e.png";